var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.riskline.length !== 0)?_c('l-geo-json',{attrs:{"geojson":_vm.selectedDateRiskData.lines,"options":{ style: _vm.styleFunction }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }